module.exports = __webpack_public_path__ + "static/4-7f0d2e17647f2fb5d7d61a104a37a28c.jpg";